<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import { Button, Container, Icon, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	const openEnergyGallery = () => {
		window.dispatchEvent(new CustomEvent('shelly:open-energy-widget-gallery'));
	};
</script>

<Container type="glass" noScroll fullHeight class="dash-energy-explore">
	<div class="dash-energy-explore-content">
		<span class="dash-energy-explore-icon" aria-hidden="true">
			<Icon icon="fal fa-grid-2-plus" size="l" />
		</span>
		<Text styleType="h2" class="text-700 text-center">
			{$format('dash_energy_explore_title', {
				default: 'Explore all our Energy Widgets and make your own dashboard',
			})}
		</Text>
		<Text styleType="body-small" class="text-color-muted text-center">
			{$format('dash_energy_explore_description', {
				default: 'Browse every energy widget and configure the view that fits your home.',
			})}
		</Text>
		<Button icon="fal fa-arrow-right" on:click={openEnergyGallery}>
			{$format('dash_energy_explore_action', { default: 'Browse Energy Widgets' })}
		</Button>
	</div>
</Container>

<style>
	.dash-energy-explore-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: var(--spacing-s);
		min-height: 190px;
		padding: var(--spacing-l);
	}

	.dash-energy-explore-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 52px;
		height: 52px;
		border-radius: var(--radius-pill);
		background: var(--color-primary-10);
		color: var(--color-primary);
	}
</style>
